import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ScenarioService } from '../services/scenario.service';
import { Router } from '@angular/router';
import { UserService } from '../auth/service/user.service';
import { LibraryService } from '../services/library.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-redeem-code',
  templateUrl: './redeem-code.component.html',
  styleUrls: ['./redeem-code.component.scss'],
})
export class RedeemCodeComponent {
  isLoading = false;
  libraryCode: any;
  error: any;
  code: any;
  environment = environment;

  constructor(
    public scenarioService: ScenarioService,
    private router: Router,
    private userService: UserService,
    private libraryService: LibraryService,
  ) {}

  ngOnInit(): void {}

  onCheckCode(form: NgForm) {
    if (!form.valid) {
      return;
    }

    this.libraryService.checkCode(form.value.code).subscribe(
      (responseData: any) => {
        this.error = null;
        this.libraryCode = responseData;
      },
      (error) => {
        console.log(error);
        this.error = error;
      },
    );
  }

  onConfirm(form: NgForm) {
    if (!form.valid) {
      return;
    }

    this.libraryService.confirmCode(this.code).subscribe(
      (responseData: any) => {
        this.error = null;
        // this.libraryCode = responseData;
        // forward it because it worked
        this.libraryService.clearCache();

        Swal.fire({
          text: 'Item added to your Library!',
          toast: true,
          position: 'top-right',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success',
        });

        this.router.navigate(['/dashboard']);
      },
      (error) => {
        this.error = error;
      },
    );
  }
}
